module.exports = __webpack_public_path__ + "img/certUFF.a92922a7.jpeg";